var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAttachment04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 5.83341V5.66675C14.6666 4.26662 14.6666 3.56655 14.3941 3.03177C14.1544 2.56137 13.772 2.17892 13.3016 1.93923C12.7668 1.66675 12.0667 1.66675 10.6666 1.66675H5.33325C3.93312 1.66675 3.23306 1.66675 2.69828 1.93923C2.22787 2.17892 1.84542 2.56137 1.60574 3.03177C1.33325 3.56655 1.33325 4.26662 1.33325 5.66675V14.3334C1.33325 15.7335 1.33325 16.4336 1.60574 16.9684C1.84542 17.4388 2.22787 17.8212 2.69828 18.0609C3.23306 18.3334 3.93312 18.3334 5.33325 18.3334H8.41659M8.41659 9.16675H4.66659M7.58325 12.5001H4.66659M11.3333 5.83341H4.66659M12.9999 15.0001V10.4167C12.9999 9.72639 13.5596 9.16675 14.2499 9.16675C14.9403 9.16675 15.4999 9.72639 15.4999 10.4167V15.0001C15.4999 16.3808 14.3806 17.5001 12.9999 17.5001C11.6192 17.5001 10.4999 16.3808 10.4999 15.0001V11.6667",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachment04);
export default __webpack_public_path__ + "static/media/file-attachment-04.42aa6d6778267007f8cb1c5429fb4288.svg";
export { ForwardRef as ReactComponent };